import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AuthContext";
import './component.css';
import { ADMIN_PREFIX } from '../../../lib/lib';

const Component = ({sidebarOpen, setSidebarOpen, toggleSidebar, brandName}) => {
  const { logout } = useAdminAuth();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const sidebarRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth > 990) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };

    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target) && windowWidth <= 990) {
        setSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [windowWidth]);

  const toggleDropdown = () => {
    setDropdownOpen(prevState => !prevState);
  };

  const closeSidebar = () => {
    if (windowWidth <= 990) {
      setSidebarOpen(false);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate(`${ADMIN_PREFIX}/login`);
    } catch (error) {
      console.error("Logout Error:", error);
    }
  };

  return (
    <>
      <div>
        <div id="mySidenav" className="sidenav" ref={sidebarRef} style={{ width: sidebarOpen ? (windowWidth > 990 ? '16.7%' : '80%') : '0' }} >
          <a className="closebtn" onClick={toggleSidebar}>&times;</a>
          <div className="desk-flx"><h2 className='admin-top'>{brandName}</h2></div>

          <div className="topMargin mt-3">
            <Link to="/admin/dashboard" className={`pages ${location.pathname === "/admin/dashboard" ? "active" : ""}`} onClick={closeSidebar}> <i className="ri-dashboard-line"></i> Dashboard </Link>
            <Link to="/admin/user" className={`pages ${location.pathname === "/admin/user" ? "active" : ""}`} onClick={closeSidebar}> <i className="ri-user-line"></i> Customers </Link>
            <Link to="/admin/hotel" className={`pages ${location.pathname === "/admin/hotel" ? "active" : ""}`} onClick={closeSidebar}> <i className="ri-hotel-line"></i> Hotels </Link>
            <Link to="/admin/category" className={`pages ${location.pathname === "/admin/category" ? "active" : ""}`} onClick={closeSidebar}> <i className="ri-file-list-line"></i> Categories </Link>
            <Link to="/admin/product" className={`pages ${location.pathname === "/admin/product" ? "active" : ""}`} onClick={closeSidebar}> <i className="ri-product-hunt-line"></i> Products </Link>
            <Link to="/admin/menu" className={`pages ${location.pathname === "/admin/menu" ? "active" : ""}`} onClick={closeSidebar}> <i className="ri-menu-line"></i> Menus </Link>
            <Link to="/admin/allorder" className={`pages ${location.pathname === "/admin/allorder" ? "active" : ""}`} onClick={closeSidebar}> <i className="ri-stock-line"></i> Orders </Link>
            {/* <Link to="/admin/visitor" className={`pages ${location.pathname === "/admin/visitor" ? "active" : ""}`} onClick={closeSidebar}> <i className="ri-home-4-line"></i> Visitor </Link> */}
            {/* 
            <Link to="/admin/homeproduct" className={`pages ${location.pathname === "/admin/homeproduct" ? "active" : ""}`} onClick={closeSidebar}> <i className="ri-home-4-line"></i> Home Page Product </Link>
            <Link to="/admin/banner" className={`pages ${location.pathname === "/admin/banner" ? "active" : ""}`} onClick={closeSidebar}> <i className="ri-flag-2-line"></i> Banner </Link>
            <Link to="/admin/vendor" className={`pages ${location.pathname === "/admin/vendor" ? "active" : ""}`} onClick={closeSidebar}> <i className="ri-group-line"></i> Vendors </Link>
            <Link to="/admin/coupon" className={`pages ${location.pathname === "/admin/coupon" ? "active" : ""}`} onClick={closeSidebar}> <i className="ri-qr-code-line"></i> Coupon </Link>
            <Link to="/admin/contact" className={`pages ${location.pathname === "/admin/contact" ? "active" : ""}`} onClick={closeSidebar}> <i className="ri-contacts-book-line"></i> Contact </Link>
            <Link to="/admin/subscribe" className={`pages ${location.pathname === "/admin/coupon" ? "subscribe" : ""}`} onClick={closeSidebar}> <i className="ri-mail-volume-line"></i> Subscribe </Link>
             */}

            <div className="top-marginn12">
              <a href='#' className="sidebar_flx" id="pages" onClick={toggleDropdown}>
                <div className="menu_txt"><i className="ri-settings-3-line"></i> Settings</div>
                <div className="maenuDroparrow"><i className="ri-arrow-down-s-line down_arow"></i></div>
              </a>
              {dropdownOpen && (
                <div className="dropdown-menu show">
                  <Link to="/admin/changePassword" className={`pages ${location.pathname === "/admin/changePassword" ? "active" : ""}`} onClick={closeSidebar}>
                    <i className="ri-arrow-right-s-line"></i> Change Password
                  </Link>
                  <a href="#" className="pages" onClick={handleLogout}><i className="ri-arrow-right-s-line"></i> Log Out</a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Component;
